import FileUploadReceipt from '../FileUploadReceipt/FileUploadReceipt';
import {useTranslation} from 'react-i18next';
import ManualReceiptInput from './ManualReceiptInput';

function ReceiptUpload(props) {
	const {t} = useTranslation();
	const {
		register,
		formState,
		resetField,
		setSavedSelectedImage,
		savedSelectedImage,
		promotionSettings,
		setImage,
		setValue
	} = props;

	return (
		<>
			{promotionSettings.promotion_type.receipt_submitting_options === "both" &&
				<div className="promo-fields-group promo-fields__border-bottom">
					<div className="promo-fields">
						<div className="promo-field">
							<>
								<h5>{t("Add your receipt")}*</h5>
								<FileUploadReceipt register={register} formState={formState} resetField={resetField}
												   imagePreview={true} setValue={setValue} setImage={setImage}
												   inputName={"file_upload"}
												   setSavedSelectedImage={setSavedSelectedImage}
												   savedSelectedImage={savedSelectedImage}
												   csrfToken={promotionSettings.csrfToken}/>
								<ManualReceiptInput register={register} formState={formState}/>
							</>
						</div>
					</div>
				</div>
			}
			{promotionSettings.promotion_type.receipt_submitting_options === "upload" &&
				<div className="promo-fields-group promo-fields__border-bottom">
					<div className="promo-fields">
						<div className="promo-field">
							<>
								<h5>{t("Add your receipt")}*</h5>
								<FileUploadReceipt register={register} formState={formState} resetField={resetField}
												   imagePreview={true} setValue={setValue} setImage={setImage}
												   inputName={"file_upload"}
												   setSavedSelectedImage={setSavedSelectedImage}
												   savedSelectedImage={savedSelectedImage}
												   csrfToken={promotionSettings.csrfToken}/>
							</>
						</div>
					</div>
				</div>
			}
			{promotionSettings.promotion_type.receipt_submitting_options === "manual" &&
				<div className="promo-fields-group promo-fields__border-bottom">
					<div className="promo-fields">
						<div className="promo-field">
							<>
								<h5>{t("Add your receipt")}*</h5>
								<ManualReceiptInput register={register} formState={formState}/>
							</>
						</div>
					</div>
				</div>
			}
			{promotionSettings.promotion_page.promotion_type === "receipt_scanning" &&
				<div className="promo-fields-group promo-fields__border-bottom">
					<div className="promo-fields">
						<div className="promo-field">
							<>
								<h5>{t("Add your receipt")}*</h5>
								<FileUploadReceipt register={register} formState={formState} resetField={resetField}
												   imagePreview={true} setValue={setValue} setImage={setImage}
												   inputName={"file_upload"}
												   setSavedSelectedImage={setSavedSelectedImage}
												   savedSelectedImage={savedSelectedImage}
												   csrfToken={promotionSettings.csrfToken}/>
							</>
						</div>
					</div>
				</div>
			}
		</>
	);
}

export default ReceiptUpload;
